import type { GrandCentral } from "@busbud/core-types";

import type { NapiClient } from "@app/services/api";
import sentry from "@app/services/sentry-facade";

const REVIEW_COUNT = 3;
const MIN_CHARACTERS_FOR_REVIEWS = 60;

export async function getProfileReviews(
  api: NapiClient,
  profile_id: number
): Promise<GrandCentral.API.TravelReview[] | null> {
  try {
    return api.getPublishedTravelReviews({
      profile_id,
      limit: REVIEW_COUNT,
      content_length_gte: MIN_CHARACTERS_FOR_REVIEWS,
      unique_by_traveller_email: true
    });
  } catch (error) {
    sentry.captureException(error, {
      tags: { controller: "results", request: "operator_reviews" }
    });

    return null;
  }
}
